goog.provide("shadow.js.shim.module$$mui$icons_material$AccountCircleRounded$default");
shadow.js.shim.module$$mui$icons_material$AccountCircleRounded$default = shadow.js.shim.module$$mui$icons_material$AccountCircleRounded.default;
